import naja from "naja";
import BeforeAfterUpdateExtension from "./BeforeAfterUpdateExtension";
import SpinnerExtension from "../../../../../admin/assets/js/components/Naja/SpinnerExtension";

class NajaHandler {
	constructor() {
		this.naja = naja;
		window.naja = this.naja;
	}

	initialize() {
		document.addEventListener("DOMContentLoaded", () => {
			this.registerExtensions();
			this.setupEventHandlers();
			this.naja.initialize();
		});
	}

	registerExtensions() {
		this.naja.registerExtension(new SpinnerExtension());
		this.naja.registerExtension(new BeforeAfterUpdateExtension());
	}

	setupEventHandlers() {

	}
}

const najaHandler = new NajaHandler();
window.najaHandler = najaHandler;
najaHandler.initialize();
